import { FacebookImageGrid, MessageImage } from "./MessageImage";
import type { Message } from "@interfaces/chat.interface";

interface MessageImageContentProps {
  message: Message;
  pageId?: string | null;
}

export const MessageImageContent = ({
  message,
  pageId,
}: MessageImageContentProps) => {
  const attachments = message.meta?.attachments as
    | Array<{
        type: string;
        payload?: { url?: string };
        url?: string;
      }>
    | undefined;

  if (attachments && Array.isArray(attachments) && attachments.length > 0) {
    const imageAttachments = attachments.filter((att) => att.type === "image");

    if (imageAttachments.length > 0) {
      return (
        <FacebookImageGrid
          images={imageAttachments.map((att) => ({
            url: att.payload?.url || att.url || "",
            attachment: att,
          }))}
          messageId={message.id}
          conversationId={message.conversationId}
          pageId={pageId}
        />
      );
    }
  }
  const imageUrl = (message.body || message.meta?.previewUrl || "") as string;
  if (!imageUrl) {
    return null;
  }
  return (
    <MessageImage
      key={`image-${message.id}`}
      src={imageUrl}
      messageId={message.id}
      conversationId={message.conversationId}
      pageId={pageId}
    />
  );
};
